<template>
  <div
    class="chat-view"
   >
    <div class="conversation-wrapper size-parents">
      <div class="flex width-expand flex-center flex-middle">
        <form-button
          class="show-conversations-button width-expand margin-auto-inline"
          style="max-width: calc(var(--base-margin) * 700);"
          v-show="!showConversations"
          theme="inverse"
          icon="chat-message"
          text="chat.conversation.selectConversationMobileCta"
          @click="showConversations = true"></form-button>
        <form-button
          class="show-conversations-button  width-expand margin-auto-inline"
          style="max-width: calc(var(--base-margin) * 700);"
          v-show="showConversations"
          theme="gray-5"
          icon="x"
          text="chat.conversation.selectConversationMobileCloseCta"
          @click="showConversations = false"></form-button>
      </div>

      <conversations
        ref="conversationsComponent"
        :class="{ active: showConversations }"
        :conversation-uuid="conversationUuid"
        class="conversations size-parents"
        @conversations:conversation-selected="
          selectConversation
        "></conversations>
    </div>

    <div class="chat-wrapper flex-column width-expand">
      <chat
        :show-header="showChatHeader"
        :max-height="chatMaxHeight"
        class="width-expand"

        @chat:message-sent="updateCurrentConversation"
        @chat:message-received="updateCurrentConversation"
        :conversation-uuid="conversationUuid"></chat>
    </div>
  </div>
</template>

<script>
import Chat from "@/client/components/chat/Chat.vue";
import Conversations from "@/client/components/chat/Conversations.vue";

export default {
  components: {
    Chat,
    Conversations,
  },
  props: {
    maxHeight: {
      type: String,
      default: "inherit",
    },

    showChatHeader: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      conversationUuid: false,
      showConversations: false,
    };
  },
  mounted() {

  },
  methods: {
    updateCurrentConversation() {
      this.updateConversation(this.conversationUuid);
    },
    updateConversation(uuid) {
      let component = this.$refs["conversationsComponent"];
      if (Array.isArray(component)) {
        component = component[0];
      }
      try {
        component.reloadConversation(uuid);
      } catch (e) {}
    },
    selectConversation(data) {
      if (!data?.conversation?.uuid) {
        return null;
      }

      this.conversationUuid = data.conversation.uuid;
      this.showConversations = false;
      if (!utilities.isSSR()) {
        setTimeout(() => {
          this.updateCurrentConversation();
        }, 100);
      }
    },
  },
  computed: {
    chatMaxHeight() {
      return `calc(${this.maxHeight} - (var(--base-margin) * 126))`;
    }
  }
};
</script>

<style scoped lang="scss">
.chat-view {
  display: flex;
  gap: var(--margin-l);
  align-items: stretch;
  width: 100%;
  @media (max-width:1024px) {
    flex-direction: column;
    gap: var(--margin-m);

  }

}
.conversation-wrapper {
  max-width: 100%;

  @media (max-width: 1024px) {
    width: 100%;
  }
}
.conversations {
  flex: 0 0 calc(var(--base-margin) * 340);
  max-width: calc(var(--base-margin) * 340);
  @media (max-width: 1024px) {
    margin-inline: auto;
    width: 100%;
    flex: 100%;
    max-width: calc(var(--base-margin) * 700);

    &:not(.active) {
      display: none;
    }
  }
}

.chat-wrapper {
  max-height: inherit;

  @media (max-width: 1024px) {
    flex: auto;
    width: 100%;
    max-width: calc(var(--base-margin) * 700);
  }
}
.show-conversations-button {
  display: none;
  @media (max-width: 1024px) {
    display: inline-block;
  }
}


//76
:deep(.chat-header) {
  min-height: calc(var(--base-margin) * 76);
}

</style>
